import forceTrailingSlash from "../../templates/utils/forceTrailingSlash";

export interface IItemListSchema {
  "@context": "https://schema.org";
  "@type": "ItemList";
  numberOfItems: number;
  itemListElement: IItemListItemSchema[];
}

export interface IItemListItemSchema {
  "@context": "https://schema.org";
  "@type": "ListItem";
  position: number;
  url: string;
}

export interface IItemListItem {
  position: number;
  path: string;
}

const itemList = (items: IItemListItem[]): IItemListSchema => {
  const itemListElements: IItemListItemSchema[] = items.map(item => {
    return {
      "@context": "https://schema.org",
      "@type": "ListItem",
      "position": item.position,
      "url": forceTrailingSlash(`https://www.gravitywell.co.uk${item.path}`)
    };
  });

  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "numberOfItems": items.length,
    "itemListElement": itemListElements
  };
};

export default itemList;
